<template>

  <el-dialog
    :title="Baslik"
    :visible="Durum"
    center
    append-to-body
    class="DonemModal"
    width="99%">
    <a @click="$emit('Durum', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>

    <el-row :gutter="24" class="mt-4">
      <el-col :span="20">

        <el-tag type="danger" v-if="SonFatura" class="mt-4 d-block text-center">
          <b>Son dönem 10 gün içinde, {{ SonFatura }} tarihinde okunmuştur.</b>
        </el-tag>
        <div v-if="AktifStep===1">
          <el-form :model="DonemBilgi" @submit.prevent.native="VeriIsle" :rules="FormHata" ref="Form">
            <el-row :gutter="24">
              <el-col :span="10">
                <el-form-item label="Bina" prop="Bina_id">
                  <el-select v-model="DonemBilgi.Bina_id" :disabled="Disabled" @change="BinaSecimi" filterable>
                    <el-option
                      v-if="Binalar"
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                      <span style="float: left">{{ item.Adi }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Yonetim }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Söz.Hes. No" prop="Referans">
                  <el-input v-model="DonemBilgi.Referans" class="input-with-select">
                    <el-button slot="append" :disabled="!DonemBilgi.Referans" @click="ReferansCek(DonemBilgi.Referans)"
                               icon="el-icon-search"></el-button>
                  </el-input>

                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="Okuma Türü" prop="oTuru">
                  <el-select v-model="DonemBilgi.oTuru" filterable>
                    <el-option
                      v-for="item in oTuru"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="Dönem Adı" prop="DonemAdi">
                  <el-input v-model="DonemBilgi.DonemAdi"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Fatura Tarihi" prop="ftarih">
                  <el-date-picker
                    v-model="DonemBilgi.ftarih"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="S.Ö. Tarihi" prop="starih">
                  <el-date-picker
                    v-model="DonemBilgi.starih"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Tutar" prop="Tutar">
                  <el-input v-model="DonemBilgi.Tutar"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item :label="DonemBilgi.oTuru!=3?'Hacim':'Tüketim kWh'" prop="Hacim">
                  <el-input v-model="DonemBilgi.Hacim"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Okuma Bedeli" prop="Okuma">
                  <el-input v-model="DonemBilgi.Okuma"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" v-if="DonemBilgi.oTuru!=3">
                <el-form-item :label="DonemBilgi.sTur=='1'?'Su Faturası':'Su Birim'" prop="SuBirim">
                  <el-input v-model="DonemBilgi.SuBirim"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span=3 v-if="DonemBilgi.oTuru!=3">
                <el-form-item label="Su F.Tür" class="Tooltip" prop="eTur">
                  <el-tooltip class="item" effect="dark"
                              content="Su Fatura Hesaplama Türü"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-radio-group v-model="DonemBilgi.sTur" size="mini">
                    <el-radio-button label="1">Tutar</el-radio-button>
                    <el-radio-button label="2">Birim</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="3" v-if="DonemBilgi.oTuru!=3">
                <el-form-item label="Su Derece" prop="SuDerece">
                  <el-input v-model="DonemBilgi.SuDerece"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left">Okuma Ayarları</el-divider>
            <el-row :gutter="24">
              <el-col :span="4">
                <el-form-item label="Ortak Alan" prop="oAlan">
                  <el-input v-model="DonemBilgi.oAlan"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="Döküm Duyuru" class="Tooltip" prop="dAciklama">
                  <el-tooltip class="item" effect="dark"
                              content="Kişi dökümünde alt not olarak yazdırılır."
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input v-model="DonemBilgi.dAciklama"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Dönem Not" prop="Sahaci">
                  <el-input v-model="DonemBilgi.Sahaci"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" v-if="DonemBilgi.oTuru!=3">

                <el-form-item label="Arıza Alt Limit" prop="ArizaUstLimit" class="Tooltip">
                  <el-tooltip class="item" effect="dark"
                              content="M2 başına kaç en az kWh ise 15 derece hesabına dahil edilmesin?"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input v-model="DonemBilgi.ArizaAltLimit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" v-if="DonemBilgi.oTuru!=3">
                <el-form-item label="Arıza Üst Limit" prop="ArizaUstLimit" class="Tooltip">
                  <el-tooltip class="item" effect="dark"
                              content="M2 başına kaç en çok kWh ise 15 derece hesabına dahil edilmesin?"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input v-model="DonemBilgi.ArizaUstLimit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left">Ekstre Borçlandırma</el-divider>
            <el-row :gutter="24">
              <el-col :span="10">
                <el-form-item label="E.Açıklama" class="Tooltip" prop="eAciklama">
                  <el-tooltip class="item" effect="dark"
                              content="Bağımsız olarak Fatura bedelinden düşülecek bedel açıklaması"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input v-model="DonemBilgi.eAciklama"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="E.Tutar" class="Tooltip" prop="eTutar">
                  <el-tooltip class="item" effect="dark"
                              content="Bağımsız olarak Fatura bedelinden düşülecek bedel açıklaması m2 göre bölünür"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input v-model="DonemBilgi.eTutar"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="E.Tür" class="Tooltip" prop="eTur">
                  <el-tooltip class="item" effect="dark"
                              content="Mesken Sayısı veya M2 göre ayarlanabilir"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-radio-group v-model="DonemBilgi.eTur" size="mini">
                    <el-radio-button label="1">M2</el-radio-button>
                    <el-radio-button label="2">Mesken</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="dialog-footer">
              <el-button-group>
                <el-button v-if="!lo && Donem_id" type="danger" size="medium" @click="fSil()">Sil</el-button>
                <el-button v-if="!lo" type="success" size="medium" @click="fKaydet()">Kaydet</el-button>
                <el-button v-if="!lo" type="primary" size="medium" @click="VeriIsle()">Kaydet ve Okuma Yap</el-button>
              </el-button-group>
            </div>
          </el-form>
        </div>
        <div v-if="AktifStep===2">
          <KisHesaplamasi v-if="DonemBilgi.oTuru==1" :HesapVeri="HesapVeri"></KisHesaplamasi>
          <YazHesaplamasi v-if="DonemBilgi.oTuru==2" :HesapVeri="HesapVeri"></YazHesaplamasi>
          <ElektrikHesaplamasi v-if="DonemBilgi.oTuru==3" :HesapVeri="HesapVeri"></ElektrikHesaplamasi>
          <div slot="footer" class="dialog-footer" v-if="DonemeDon">
            <el-button @click="AktifStep=1" type="info" size="medium">Dönem Ekranı</el-button>
            <el-button v-if="!lo" type="primary" size="medium" @click="Onayla()"
                       icon="el-icon-check">Hesaplamayı Onayla
            </el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <table class="table" v-if="SecilenBina">
          <thead>
          <tr>
            <th class="text-center">BİNA BİLGİLERİ</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="SecilenBina.ufirma">
            <td>
              <el-button type="primary" size="mini" @click="UzaktanOkumaModalDurum=true" class="btn-block">
                {{ SecilenBina.ufirma }} Uzaktan Okuma
              </el-button>
            </td>
          </tr>
          <tr>
            <td>
              <el-button type="success" size="mini" @click="MeskenListesiModal=true" class="btn-block">Bina Ekran
              </el-button>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">
                İLETİŞİM
              </small>
              {{ SecilenBina.Ilgili }} <br> {{ SecilenBina.Iletisim }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">
                REFERANS NO
              </small>
              {{ SecilenBina.Referans }}
            </td>
          </tr>

          </tbody>
        </table>
        <Notlar v-if="Notlars" :data="Notlars"></Notlar>
      </el-col>
    </el-row>
    <UzaktanOkumaModal v-if="UzaktanOkumaModalDurum" :Data="SecilenBina" :Durum="UzaktanOkumaModalDurum"
                       @Durum="UzaktanOkumaModalDurum=false"></UzaktanOkumaModal>

    <el-dialog
      title="Bina Ekran"
      :visible.sync="MeskenListesiModal"
      append-to-body
      width="95%">
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="MeskenListesiModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Detay v-if="MeskenListesiModal" :Bina_id="SecilenBina.id"></Detay>
    </el-dialog>

  </el-dialog>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import KisHesaplamasi from "./KisHesaplamasi";
import YazHesaplamasi from "./YazHesaplamasi";
import Notlar from "../../../components/Pack/Genel/Notlar";
import UzaktanOkumaModal from "../Bina/UzaktanOkumaModal";
import Detay from "../Bina/Detay";
import ElektrikHesaplamasi from "./ElektrikHesaplamasi";


export default {
  components: {ElektrikHesaplamasi, Detay, UzaktanOkumaModal, Notlar, YazHesaplamasi, KisHesaplamasi, Yukleniyor},
  props: ['Donem_id', 'Durum', 'Taslak', 'Bina_id', 'Binalar', 'DonemAdi'],
  data() {
    return {
      Height: window.innerHeight - 190,
      Baslik: 'Dönem Oluştur',
      Data: null,
      DonemeDon: true,
      CarpanHesap: 0,
      SecilenBina: null,
      Disabled: false,
      UzaktanOkumaModalDurum: false,
      MeskenListesiModal: false,
      SonFatura: null,
      AktifStep: 1,
      lo: false,
      Modal: false,
      oTuru: [{Adi: 'Kış Okuması', id: "1"}, {Adi: 'Yaz Okuması', id: "2"}, {Adi: 'Elektrik Okuması', id: "3"}],
      DonemBilgi: {
        Bina_id: null,
        oTuru: "1",
        DonemAdi: null,
        Referans: null,
        Tutar: 0,
        Hacim: 0,
        ftarih: null,
        starih: null,
        Okuma: null,
        Tahsil: null,
        SuBirim: 0,
        SuDerece: 55,
        oAlan: 30,
        dAciklama: "",
        eAciklama: "",
        Sahaci: "",
        eTutar: 0,
        eTur: 1,
        sTur: 1,
        ArizaAltLimit: "1",
        ArizaUstLimit: "50",
      },
      Notlars: null,
      FormHata: {
        DonemAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Hacim: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        ftarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        starih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Okuma: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        oAlan: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      HesapVeri: null,
      OnayVeri: null,

    }
  },
  methods: {
    ReferansCek(Referans) {

      var b = this.Binalar.filter(data => data.Referans === Referans)[0];
      // var b = this.Binalar.Referans.toLowerCase().includes(Referans.toLowerCase())[0];
      if (!b) this.$message.error("Sözleşme Hesap Numarasına kayıtlı bina bulunamadı."); else this.$message.success("Bina bilgisi getirildi");
      this.BinaSecimi(b.id)
    },
    BinaSecimi(Bina_id) {

      // var dBina_id = this.DonemBilgi.Bina_id ? this.DonemBilgi.Bina_id : Bina_id;
      // this.SecilenBina = this.Binalar.filter(c => c.id.includes(dBina_id))[0];

      this.$store.dispatch("Post", {path: '_enerji/donem/faturadetay/' + Bina_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.SecilenBina = response.SecilenBina;
            if (this.SecilenBina.Fatura) {
              this.DonemBilgi = {
                Bina_id: this.SecilenBina.id,
                oTuru: this.SecilenBina.Fatura.Tur,
                DonemAdi: this.SecilenBina.Fatura.aciklama,
                Referans: this.SecilenBina.Referans,
                Tutar: this.SecilenBina.Fatura.tutar,
                Hacim: this.SecilenBina.Fatura.hacim,
                ftarih: this.SecilenBina.Fatura.ftarih,
                starih: this.SecilenBina.Fatura.starih,
                Okuma: this.SecilenBina.Fatura.Okuma,
                Tahsil: this.SecilenBina.Fatura.Tahsil,
                SuBirim: this.SecilenBina.Fatura.SuBirim,
                SuDerece: this.SecilenBina.Fatura.SuDerece,
                oAlan: this.SecilenBina.Fatura.oAlan ? this.SecilenBina.Fatura.oAlan : 30,
                dAciklama: this.SecilenBina.Fatura.dAciklama,
                eAciklama: this.SecilenBina.Fatura.eAciklama,
                Sahaci: this.SecilenBina.Fatura.Sahaci,
                eTutar: this.SecilenBina.Fatura.eTutar,
                eTur: this.SecilenBina.Fatura.eTur,
                sTur: this.SecilenBina.Fatura.sTur,
                ArizaAltLimit: this.SecilenBina.Fatura.ArizaAltLimit ? this.SecilenBina.Fatura.ArizaAltLimit : "1",
                ArizaUstLimit: this.SecilenBina.Fatura.ArizaUstLimit ? this.SecilenBina.Fatura.ArizaUstLimit : "50",
              }
            } else {
              this.DonemBilgi = {
                Bina_id: this.SecilenBina.id,
                oTuru: "1",
                DonemAdi: this.DonemAdi,
                Referans: this.SecilenBina.Referans,
                Dosya: false,
                Tutar: 0,
                Hacim: 0,
                ftarih: null,
                starih: null,
                Okuma: this.SecilenBina.OkumaUcreti,
                Tahsil: this.SecilenBina.TahsilUcreti,
                SuBirim: 0,
                SuDerece: 55,
                oAlan: 30,
                dAciklama: "",
                Sahaci: "",
                eAciklama: "",
                eTutar: 0,
                Sms: 0,
                eTur: 1,
                sTur: 1,
                ArizaAltLimit: "1",
                ArizaUstLimit: "50",
              }

            }
            this.SonFatura = this.SecilenBina.SonFatura;
            this.Notlars = null
            setTimeout(() => {
              this.Notlars = {
                Modul: 's_Bina',
                Modul_id: this.DonemBilgi.Bina_id
              }
            }, 100);
          }
        });

    },
    Onayla() {
      this.$confirm("Borçlandırma onaylanıp, bina yönetimlerinin ekranlarına düşürülecektir.<br>  Aynı zamanda dökümler ekranına üretilecek ve iptal edilmesi zorlaşacaktır. <br> İşlemi onaylıyormusunuz?", "Hesaplama Onayı", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.Borclandirma()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });

    }
    ,
    Borclandirma() {

      this.$alert('İşlem tamamlanana kadar bekleyiniz.<br> İşlem tamamlanınca liste ekranına geçiş yapılacaktır', 'Veri İşleniyor', {
        confirmButtonText: 'Bekleyiniz',
        type: 'info',
        showConfirmButton: false,
        showCancelButton: false,
        dangerouslyUseHTMLString: true
      });
      this.DonemeDon = false;

      //$(".el-message-box__btns button").remove();


      this.lo = true;
      this.$store.dispatch("Post", {
        Data: this.HesapVeri,
        path: '_enerji/donem/onay/'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            window.location.reload();
            //this.OnayVeri = response.Hesaplama;
            //this.AktifStep = 3;

          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    }
    ,
    fSil() {
      this.$confirm(" İşlemi onaylıyormusunuz?", "Fatura Bilgisi Silinecek", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.SilOnayla()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });

    }
    ,
    SilOnayla() {
      this.lo = true;
      this.$store.dispatch("Post", {
        path: '_enerji/donem/sil/' + this.Donem_id
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.$emit('Durum', false)
          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    }
    ,
    fKaydet() {
      this.FormHata = {
        DonemAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }

      this.$refs['Form'].validate((valid) => {
        if (valid) {

          this.lo = true;
          this.$store.dispatch("Post", {
            Data: this.DonemBilgi,
            path: '_enerji/donem/fatura'
          })
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.$message.success(response.Mesaj);
                this.$emit('Durum', false)
              } else {
                this.$message.warning(response.Mesaj);
              }
            })
        }
      })
    }
    ,
    VeriIsle() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {

          this.lo = true;
          this.$store.dispatch("Post", {
            Data: this.DonemBilgi,
            path: '_enerji/donem/veri'
          })
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.HesapVeri = response.Hesaplama;
                this.AktifStep = 2;
                this.CarpanHesap = this.HesapVeri.Hesap.tCarpan;
                //this.Hesapla()
              } else {
                this.$message.warning(response.Mesaj);
              }
            })
        }
      })
    }
    ,

    SayfaYukle() {


      if (this.Taslak === false) {
        if (this.Donem_id) {
          this.lo = true;
          this.$store.dispatch("Get", {path: '_enerji/donem/' + this.Donem_id})
            .then(response => {

              if (response.Durum === 'OK') {
                this.Data = response.Data;
                this.DonemAdi = response.DonemAdi;

                setTimeout(() => {
                  this.lo = false;
                  this.BinaSecimi(response.Data.Bina_id);
                }, 100);
              } else {
                this.lo = false;
                this.$message.error(response.Mesaj);
              }
            });
        }
      } else {
        this.DonemBilgi.Bina_id = this.Bina_id;
        this.BinaSecimi(this.DonemBilgi.Bina_id)
        if (this.Bina_id) this.Baslik = this.SecilenBina.Adi + ' Dönem Ekranı';

      }
    }
  },
  created() {
    if (this.Donem_id) this.SayfaYukle();
    if (this.Donem_id) this.Disabled = true
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Donem/DonemModal.vue